import { useEffect, useState } from "react";
import { fetchGrades } from "../Api/ViewGradeMaster";
import { Container, Table } from "react-bootstrap";
//import "../Styling/ViewGradeMaster.css";
import { toast } from "react-toastify";
import moment from "moment";

const ViewGradeMaster = () => {
  const [grades, setGrades] = useState([]);

  useEffect(() => {
    const loadGrades = async () => {
      try {
        const data = await fetchGrades();
        setGrades(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Grades`);
      }
    };

    loadGrades();
  }, []);

  return (
    <>
        <div className="main-content expand">
          <Container fluid className="list-container">
            <h2 className="list-title">View Grades</h2>

            {grades.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Grade ID</th>
                    <th>Grade</th>
                    <th>Description</th>
                    <th>Created At</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  {grades.map((grade, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{grade.gradeID}</td>
                      <td>{grade.grade}</td>
                      <td>{grade.description}</td>
                      <td>{moment(grade.createdAt).format('L')} at {moment(grade.createdAt).format('LTS')}</td>
                      <td>{grade.createdBy}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No grades found.</p>
            )}
          </Container>
        </div>
    </>
  );
};

export default ViewGradeMaster;